import {
  Box,
  Button,
  Drawer,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useThemeRender from "../../theme/useThemeRender";
import "./ViewSummary.css";
import { useDispatch, useSelector } from "react-redux";
import {
  setSummaryButton,
  setViewSummaryDrawer,
} from "../../slices/viewSummarySlice";

import { getAPI, patchAPI } from "../../API/ApiService";
import { BASE_URL } from "../../constant/apiUrl";
import ViewSummaryDetail from "./ViewSummaryDetail";
import Loading from "../../utils/Loader";
import { setAlert } from "../../slices/spotlightSlice";
import { darkTheme } from "../../theme/Theme";
import { handleResizeStart } from "../../utils/function";
import axios from "axios";
import { setPage, setReset } from "../../slices/adminPageSlice";
import { showSuccessToast } from "../../utils/Toast/toast";

function ViewSummary() {
  const [drawerHeight, setDrawerHeight] = useState("90%");
  const isMobile = useMediaQuery("(max-width:600px)");
  const isDarkTheme = useSelector((store) => store.theme);
  const { viewSummaryDrawer, viewPageName, summaryDetails, displayButton } =
    useSelector((store) => store.viewSummary);
  const { spotlight } = useSelector((store) => store.spotlight);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pageData, setPageData] = useState();
  const dispatch = useDispatch();
  const { replaceId } = useParams();
  const token = localStorage.getItem("auth_token");
  const contentId = summaryDetails?.contentId
    ? summaryDetails?.contentId
    : summaryDetails?.id;

  const finalId = contentId !== undefined ? contentId : replaceId;

  const fetchData = async () => {
    setLoading(true);

    try {
      const response = await getAPI(
        `${BASE_URL}/content/find-detail-by-id/${finalId}`
      );
      if (response?.status === 200) {
        setPageData(response?.data);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [contentId]);
  const navigate = useNavigate();
  const addViewCount = async (contentId, goTo, pageName) => {
    setLoading(true);
    try {
      const response = await patchAPI(`${BASE_URL}/content/${contentId}`, {});
      if (response?.status === 200) {
        const data = { ...summaryDetails, content: viewPageName };
        navigate(goTo, { state: data });
        setLoading(false);
        dispatch(setViewSummaryDrawer(false));
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  const handleNavigate = () => {
    if (pageData?.contentType === "LINK") {
      addViewCount(finalId, `/link/${finalId}`, "Links");
    } else if (pageData?.contentType === "DOCUMENT") {
      addViewCount(finalId, `/document/${finalId}`, "Documents");
    } else if (pageData?.contentType === "VIDEO") {
      addViewCount(finalId, `/video-details/${finalId}`, "Videos");
    }
  };

  const handleItem = async () => {
    if (!replaceId) {
      const spotPayload = spotlight.map((item) => {
        return { contentId: item.contentId, slotNumber: item.slotNumber };
      });
      spotPayload.push({
        contentId: finalId,
        slotNumber: spotPayload.length + 1,
      });
      const response = await axios.put(
        `${BASE_URL}/spotlights/update`,
        spotPayload,
        {
          headers: {
            Authorization: `Bearer ${token}`,

            "Content-Type": "application/json",
          },
        }
      );
      if (response?.status === 200) {
        navigate("/admin");
        showSuccessToast("Item successfully added");
        dispatch(setPage("In the spotlight"));
        dispatch(setReset(false));
      }
    } else {
      dispatch(setAlert(true));
    }
    dispatch(setViewSummaryDrawer(false));
    dispatch(setSummaryButton(false));
  };
  return (
    <Drawer
      anchor={isMobile ? "bottom" : "right"}
      open={viewSummaryDrawer}
      onClose={() => dispatch(setViewSummaryDrawer(false))}
      PaperProps={{
        sx: {
          height: isMobile ? drawerHeight : "100%",
          overflowY: "auto",
          maxWidth: isMobile ? "100%" : "466px",
          minWidth: "300px",
        },
      }}
      ModalProps={{
        BackdropProps: {
          sx: {
            backgroundColor: useThemeRender("drawerOverlayColorLayer1"),
          },
        },
      }}
    >
      {loading && <Loading />}
      {isMobile && (
        <Box
          sx={{
            width: "44px",
            height: "5px",
            background:
              "linear-gradient(0deg, rgba(61, 61, 61, 0.5) 0%, rgba(61, 61, 61, 0.5) 100%), rgba(127, 127, 127, 0.4)",
            backgroundBlendMode: "overlay, luminosity",
            borderRadius: "2.5px",
            position: "absolute",
            top: "10px",
            left: "50%",
            transform: "translateX(-50%)",
            cursor: "ns-resize",
            zIndex: 1,
          }}
          onMouseDown={(e) => handleResizeStart(e, setDrawerHeight)}
          onTouchStart={(e) => handleResizeStart(e, setDrawerHeight)}
        />
      )}
      <Box
        sx={{
          display: "flex",
          padding: "16px 24px",
          flexDirection: "column",
          gap: "var(--Spacing-spacing-24, 24px)",
          margin: 0,
          backgroundColor: useThemeRender("backgroundColorLayer2"),
        }}
      >
        <IconButton
          onClick={() => {
            dispatch(setSummaryButton(false));
            dispatch(setViewSummaryDrawer(false));
          }}
          sx={{
            position: "absolute",
            top: "16px",
            right: "16px",
            zIndex: 10,
          }}
          data-testid="icon-button"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
              fill={useThemeRender("iconColor1")}
            />
          </svg>
        </IconButton>
        <Box
          sx={{
            display: "flex",
            justifyContent: { xs: "flex-start", sm: "space-between" },
            alignItems: { xs: "flex-start", sm: "flex-start" },
            gap: "16px",
            alignSelf: { xs: "stretch", sm: "auto" },
            flexDirection: { xs: "column" },
            marginTop: "36px",
            width: "100%",
            padding: "0px",
          }}
        >
          <Typography
            sx={{
              color: useThemeRender("textColorLayer2"),
              fontFeatureSettings: "'liga' off, 'clig' off",
              fontFamily: "var(--Typography-Font-Family-Heading, Inter)",
              fontSize: "var(--Font-Size-H4, 28px)",
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: "var(--Line-Height-H4, 40px)",
            }}
          >
            {pageData?.title}
          </Typography>
          <Box
            onClick={() => handleNavigate()}
            style={{ width: "100%" }}
            data-testid="navigate-button"
          >
            <Button
              sx={{
                display: "flex",
                width: "100%",
                height: "40px",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                alignSelf: "stretch",
                borderRadius: "var(--Corner-radius-effect-corner-3, 24px)",
                background: "var(--Tokens-Button-Primary, #005CBC)",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  height: "var(--Spacing-spacing-40, 40px)",
                  padding:
                    "var(--Spacing-spacing-03, 8px) var(--Spacing-spacing-05, 24px)",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "var(--Spacing-spacing-03, 8px)",
                }}
              >
                <Typography
                  sx={{
                    color: "var(--Colors-White, #FFF)",
                    fontFamily: "var(--Typography-Font-Family-Body, Inter)",
                    fontSize: "var(--Font-Size-Body, 16px)",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "var(--Line-Height-Body, 22px)",
                    textTransform: "none",
                  }}
                >
                  Go to details
                </Typography>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z"
                    fill="white"
                  />
                </svg>
              </Box>
            </Button>
          </Box>
        </Box>
        <Box
          className="DetailCard"
          sx={{
            background: useThemeRender("backgroundColorLayer1"),
          }}
        >
          <Typography
            className="SummaryTitle"
            sx={{
              color: useThemeRender("textColorLayer2"),
            }}
          >
            Summary
          </Typography>
          <Typography
            className="DetailContents"
            sx={{
              color: useThemeRender("textColorLayer2"),
            }}
            dangerouslySetInnerHTML={{ __html: pageData?.summary || "" }}
          />
        </Box>
        <ViewSummaryDetail pageData={pageData} viewPageName={viewPageName} />
        <Box
          className="DetailCard"
          sx={{
            background: useThemeRender("backgroundColorLayer1"),
          }}
        >
          <Typography
            className="SummaryTitle"
            sx={{
              color: useThemeRender("textColorLayer2"),
            }}
          >
            Disclaimer
          </Typography>
          <Box className="SummaryContentBox">
            <Typography
              className="DetailContents"
              sx={{
                color: useThemeRender("textColorLayer2"),
              }}
            >
              {pageData?.disclaimer}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          position: "sticky",
          bottom: "0px",

          height: "var(--Spacing-spacing-64, 64px)",
          padding:
            "var(--Spacing-spacing-04, 16px) var(--Spacing-spacing-05, 24px)",
          alignSelf: "stretch",
          background: isDarkTheme
            ? darkTheme.backgroundColorLayer2
            : "var(--Tokens-Background-Layer-01, #FBFCFE)",
          boxShadow: displayButton
            ? "0px 1px 0px 0px var(--Tokens-Border-Divider, #DFDFDF) inset"
            : "",
        }}
      >
        {displayButton && (
          <div className=" bg-white ">
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
                flexDirection: "row",
                gap: "8px",
              }}
            >
              <Button
                sx={{
                  display: "flex",
                  height: "32px", // Using the fallback value
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "24px", // Using the fallback value
                  border: "1px solid #005CBC", // Using the fallback value
                  textTransform: "none",
                }}
                onClick={() => {
                  dispatch(setViewSummaryDrawer(false));
                  dispatch(setSummaryButton(false));
                }}
              >
                <Typography
                  sx={{
                    color: "#005CBC", // Fallback value
                    fontFamily: "Inter", // Fallback value
                    fontSize: "14px", // Fallback value
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "20px", // Fallback value
                  }}
                >
                  Cancel
                </Typography>
              </Button>
              <Button
                sx={{
                  display: "flex",
                  height: "32px", // Using the fallback value
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "24px", // Using the fallback value
                  border: "1px solid #005CBC", // Using the fallback value
                  textTransform: "none",
                  backgroundColor: "#005CBC",
                }}
                onClick={handleItem}
              >
                <Typography
                  sx={{
                    color: "#fff", // Fallback value
                    fontFamily: "Inter", // Fallback value
                    fontSize: "14px", // Fallback value
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "20px", // Fallback value
                  }}
                >
                  {!replaceId ? "Add item" : "Use this item"}
                </Typography>
              </Button>
            </Box>
          </div>
        )}
      </Box>
    </Drawer>
  );
}

export default ViewSummary;
